import { setEditWidgetGroupBy } from 'actions/dashboardEdit';
import SelectRedesign from 'components/Select/SelectRedesign';
import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getDashboardState } from 'selectors/dashboardEdit';
import { useSelector } from 'store';

interface DaysOutOfRetentionFilterProps {
  className?: string;
}

enum GroupOption {
  initial = '',
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
}

export const groupByOptions: Record<string, string> = {
  [GroupOption.hour.toString()]: 'Hour',
  [GroupOption.day.toString()]: 'Day',
  [GroupOption.week.toString()]: 'Week',
  [GroupOption.month.toString()]: 'Month',
};

const GroupByFilter: FunctionComponent<DaysOutOfRetentionFilterProps> = ({ className }) => {
  const dispatch = useDispatch();
  const { activeUuid } = useParams<{ activeUuid: string }>();
  const dashboardState = useSelector(getDashboardState(activeUuid || ''));

  const widget = dashboardState.widgets[0];

  const groupBy = widget.metrics?.[0].unit_of_time;

  const handleDateOptionChanged = (groupOpt: string): void => {
    dispatch(setEditWidgetGroupBy(groupOpt));
  };

  return (
    <div className={`flex flex-col gap-2 mt-2 shadow-sm ${className || ''}`}>
      <div className="bg-litlingo-success-light bg-opacity-10 rounded ">
        <SelectRedesign
          className="bg-transparent border-none"
          valueClassName="text-white"
          optionClassname="text-litlingo-gray-6"
          onChange={(value): void => {
            handleDateOptionChanged(value);
          }}
          options={Object.entries(groupByOptions).map(([value, label]) => ({ value, label }))}
          value={groupBy ?? GroupOption.initial}
          placeholder="Select a date range"
          optionComponent={(
            value: string,
            label: string,
            onChange: (option: string) => void
          ): JSX.Element => (
            <button
              type="button"
              className={`w-full text-body text-left border-litlingo-gray-2 p-2 focus:outline-none hover:bg-litlingo-gray-1 ${
                groupBy === value ? 'font-bold cursor-default' : 'cursor-pointer'
              }`}
              onClick={(): void => onChange(value)}
            >
              <div className="flex flex-row justify-between">
                <span>{label}</span>
              </div>
            </button>
          )}
        />
      </div>
    </div>
  );
};

export default GroupByFilter;
